angular
  .module('contabilidad.asociarfacturas')
  .service('ContabilidasAsociarFacturas', ContabilidasAsociarFacturas)

ContabilidasAsociarFacturas.$inject = ['$http']

function ContabilidasAsociarFacturas ($http) {
  this.getEmpresas = getEmpresas
  this.getListado = getListado
  this.asignarFacturas = asignarFacturas

  function getEmpresas () {
    return $http.get('/kendu/contabilidad/asociarfacturas/empresas')
  }

  function getListado (busqueda) {
    return $http.get('/kendu/contabilidad/asociarfacturas/listado', {
      params: {
        empresa: busqueda.empresa,
        cuentabancaria: busqueda.cuentabancaria,
        fechaInicial: busqueda.fechaInicial.toYMD(),
        fechaFinal: busqueda.fechaFinal.toYMD(),
        empresa_receptor: busqueda.empresa_receptor,
        cuentabancaria_receptor: busqueda.cuentabancaria_receptor,
        // naturaleza    : busqueda.naturaleza
      },
      schema: schema,
    })
  }

  function asignarFacturas (busqueda, data) {
    return $http.post('/kendu/contabilidad/asociarfacturas/asignarfacturas', {data: data}, {
      params: {
        empresa: busqueda.empresa,
        cuentabancaria: busqueda.cuentabancaria,
        fechaInicial: busqueda.fechaInicial.toYMD(),
        fechaFinal: busqueda.fechaFinal.toYMD(),
        empresa_receptor: busqueda.empresa_receptor,
        cuentabancaria_receptor: busqueda.cuentabancaria_receptor,
      },
      schema: schema,
    })
  }

  var schema = {
    Fecha: 'date',
    Importe: 'number',
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/asociarfacturas/services/ContabilidadAsociarFacturas.js